export var isDebugMode = function isDebugMode() {
  return typeof window !== 'undefined' && window.location.search.indexOf('gadebugmode=true') !== -1;
};